// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "./turbo_streams"
import * as bootstrap from "bootstrap"


document.addEventListener("turbo:load", () => {
  // Only scroll if there is no turbo-frame targeted
  if (!document.querySelector("turbo-frame")) {
    window.scrollTo(0, 0)
  }
})



document.addEventListener("turbo:load", () => {
  const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))

  popoverTriggerList.map(el =>
    new bootstrap.Popover(el, {
      html: true,
      container: 'body',
      placement: 'auto',
      fallbackPlacements: ['top', 'right', 'bottom', 'left']
    })
  )
})

